export const isValidHexColor = (hex) => {
  const regex = /^#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return regex.test(hex);
};

const normalizeHexToSixDigits = (hex) => {
  if (typeof hex !== "string") {
    return null;
  }

  const sanitizedValue = hex.trim();
  if (!sanitizedValue) {
    return null;
  }

  const withHash = sanitizedValue.startsWith("#")
    ? sanitizedValue
    : `#${sanitizedValue}`;

  if (!isValidHexColor(withHash)) {
    return null;
  }

  if (withHash.length === 4) {
    const [, r, g, b] = withHash;
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }

  if (withHash.length === 9) {
    return `#${withHash.slice(1, 7)}`.toLowerCase();
  }

  return withHash.toLowerCase();
};

export const hexToRgb = (hex) => {
  const normalizedHex = normalizeHexToSixDigits(hex);

  if (!normalizedHex) {
    return null;
  }

  return {
    r: parseInt(normalizedHex.slice(1, 3), 16),
    g: parseInt(normalizedHex.slice(3, 5), 16),
    b: parseInt(normalizedHex.slice(5, 7), 16),
  };
};

export const hexToRgbaHex = (hexOrCssVar, alpha) => {
  let hex = hexOrCssVar;
  if (hexOrCssVar.startsWith("var(")) {
    const rootStyles = getComputedStyle(document.documentElement);
    // Strip 'var(' and ')' to get the CSS variable name, then trim in case of CSS formatting
    const varName = hexOrCssVar.replace(/^var\((.*)\)$/, "$1").trim();
    hex = rootStyles.getPropertyValue(varName).trim();
  }
  const normalizedHex = normalizeHexToSixDigits(hex);
  if (!normalizedHex) {
    return null;
  }
  const { r, g, b } = hexToRgb(normalizedHex);
  const a = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, "0");
  return `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}${a}`;
};
